
export function detectaTipoDocumentoMigratorio(valor: string): 'RNE' | 'RNM' | 'DESCONHECIDO' {
  if (!valor) return 'DESCONHECIDO';

  const doc = valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  if (/^[A-Z]{2}\d{9}$/.test(doc)) return 'RNM'; // RNM oficial
  if (/^\d{9}$/.test(doc)) return 'RNM';        // RNM numérico
  if (/^\d{8,10}$/.test(doc)) return 'RNE';     // RNE numérico
  if (/^[A-Z]\d{7,9}$/.test(doc)) return 'RNE'; // RNE com letra

  return 'DESCONHECIDO';
}

export function maskRNM(valor: string): string {
  if (!valor) return '';

  let clean = valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  const letras = clean.substring(0, 2).replace(/[^A-Z]/g, '');
  const numeros = clean.substring(letras.length).replace(/\D/g, '').substring(0, 9);

  return letras + numeros;
}

export function maskRNE(valor: string): string {
  if (!valor) return '';

  let clean = valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  // Letra inicial opcional
  const letra = /^[A-Z]/.test(clean) ? clean[0] : '';
  const numeros = clean.substring(letra ? 1 : 0).replace(/\D/g, '').substring(0, 10);

  return letra + numeros;
}

export function maskRNEFormatado(valor: string): string {
  if (!valor) return '';

  let clean = valor.replace(/\D/g, '').substring(0, 9); // RNE mais comum: 9 dígitos

  clean = clean.replace(/(\d{2})(\d)/, '$1.$2');
  clean = clean.replace(/(\d{3})(\d)/, '$1.$2');
  clean = clean.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  return clean;
}

export function maskDocumentoMigratorio(valor: string): string {
  const tipo = detectaTipoDocumentoMigratorio(valor);

  if (tipo === 'RNM') {
    return maskRNM(valor);
  }

  if (tipo === 'RNE') {
    return maskRNE(valor); // Ou maskRNEFormatado(valor)
  }

  return valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}
